import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.383 2.333h-6.766c-.794 0-1.914.467-2.474 1.027L3.36 8.143c-.56.56-1.027 1.68-1.027 2.474v6.766c0 .794.467 1.914 1.027 2.474l4.783 4.783c.56.56 1.68 1.027 2.474 1.027h6.766c.794 0 1.914-.467 2.474-1.027l4.783-4.783c.56-.56 1.027-1.68 1.027-2.474v-6.766c0-.794-.467-1.914-1.027-2.474L19.857 3.36c-.56-.56-1.68-1.027-2.474-1.027m-7.466 15.75 8.166-8.166m0 8.166L9.917 9.917"
    }, null, -1)
  ]))]))
}
export default { render: render }